// src/slices/companygps/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getCompanyGps, getCompanyGpsCategories, getCompanyGpsBySlug, createCompanyGpsFromUser } from "./thunk";

const initialState = { list: [], categories: [], pagination: {}, loading: false, error: null, singleCompanyGps: null, createSuccess: false };

const companyGpsSlice = createSlice({
  name: "companyGps",
  initialState,

  reducers: {
    clearCompanyGps: (state) => {
      state.list = [];
      state.categories = [];
      state.error = null;
      state.singleCompanyGps = null;
      state.pagination = {};
      state.createSuccess = false;
    }
  },

  extraReducers: (builder) => {
    builder

      // =====================
      // GET COMPANY GPS LIST
      // =====================
      .addCase(getCompanyGps.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getCompanyGps.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload?.data?.data || action.payload;
        state.pagination = action.payload?.data?.responseDetails?.pagination || {};
      })

      .addCase(getCompanyGps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // =====================
      // GET CATEGORIES
      // =====================
      .addCase(getCompanyGpsCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getCompanyGpsCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload?.data || action.payload;
      })

      .addCase(getCompanyGpsCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // =====================
      // GET COMPANY GPS BY SLUG
      // =====================
      .addCase(getCompanyGpsBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getCompanyGpsBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.singleCompanyGps = action.payload?.data;
      })

      .addCase(getCompanyGpsBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // =====================
      // CREATE COMPANY GPS
      // =====================
      .addCase(createCompanyGpsFromUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.createSuccess = false;
      })

      .addCase(createCompanyGpsFromUser.fulfilled, (state, action) => {
        state.loading = false;
        state.createSuccess = true;
      })

      .addCase(createCompanyGpsFromUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.createSuccess = false;
      });
  }
});

export const { clearCompanyGps } = companyGpsSlice.actions;

export default companyGpsSlice.reducer;
